var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromotion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.41948 1.17121C7.18641 0.942929 6.81358 0.942931 6.58052 1.17121L5.3336 2.39251C5.22309 2.50075 5.07501 2.56209 4.92034 2.5637L3.17503 2.5818C2.84882 2.58519 2.58519 2.84882 2.5818 3.17503L2.5637 4.92034C2.56209 5.07501 2.50075 5.22309 2.39251 5.3336L1.17121 6.58052C0.942929 6.81359 0.942931 7.18642 1.17121 7.41948L2.39251 8.6664C2.50075 8.77691 2.56209 8.92498 2.5637 9.07966L2.5818 10.825C2.58519 11.1512 2.84882 11.4148 3.17503 11.4182L4.92034 11.4363C5.07501 11.4379 5.22309 11.4992 5.3336 11.6075L6.58052 12.8288C6.81358 13.0571 7.18641 13.0571 7.41948 12.8288L8.6664 11.6075C8.77691 11.4992 8.92498 11.4379 9.07966 11.4363L10.825 11.4182C11.1512 11.4148 11.4148 11.1512 11.4182 10.825L11.4363 9.07966C11.4379 8.92498 11.4992 8.77691 11.6075 8.6664L12.8288 7.41948C13.0571 7.18642 13.0571 6.81359 12.8288 6.58052L11.6075 5.3336C11.4992 5.22309 11.4379 5.07501 11.4363 4.92034L11.4182 3.17503C11.4148 2.84882 11.1512 2.58519 10.825 2.5818L9.07966 2.5637C8.92498 2.56209 8.77691 2.50075 8.6664 2.39251L7.41948 1.17121Z",
    stroke: "#142A31",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotion);
export default __webpack_public_path__ + "static/media/promotion.136c83084905a1810465e8ebc1e60051.svg";
export { ForwardRef as ReactComponent };